import { ChartLineUpIcon, ChatCircleTextIcon, ChatsCircleIcon, ClockIcon, EnvelopeSimpleIcon, FlagIcon, GitMergeIcon, GitPullRequestIcon, HourglassIcon, IdentificationCardIcon, MoonIcon, NotePencilIcon, PauseCircleIcon, PlayCircleIcon, PlugIcon, WarningCircleIcon, WarningIcon } from "@phosphor-icons/react";
import type * as C from "@zooi/contracts";

// Shared by the inbox and the dashboard's inbox block (docs/design-system.md §0.4i, 2026-10-30).

/** The item's type as a plain glyph; a hue only where it means something: amber for a warning, red for a failure. */
export function InboxItemIcon({ item }: { item: C.InboxItem }) {
  const tone = (value: string) => <span className="z-tone-icon" data-tone={value}>{glyph(item)}</span>;
  if (item.reason.code === "run_overdue" || item.kind === "run_missed" || item.kind === "connection" || item.reason.code === "work_order_approval_expired" || item.kind === "run_stalled" || item.kind === "product_idle" || item.kind === "plans_idle") return tone("amber");
  if (item.reason.code === "post_link_failed" || item.reason.code === "work_order_failed" || item.kind === "connection_failing") return tone("red");
  if (item.kind === "run_request" || item.kind === "merge") return tone("accent");
  return tone("gray");
}

function glyph(item: C.InboxItem) {
  switch (item.kind) {
    case "run_request": return <PlayCircleIcon size={16} />;
    case "run_missed": return <WarningIcon size={16} />;
    case "runs_degraded": return <PauseCircleIcon size={16} />;
    case "connection": return <PlugIcon size={16} />;
    case "connection_failing": return <PlugIcon size={16} />;
    case "plan": return <GitPullRequestIcon size={16} />;
    case "campaign_reading": return <FlagIcon size={16} />;
    case "reading": return <FlagIcon size={16} />;
    case "outreach": return <EnvelopeSimpleIcon size={16} />;
    case "reply_queue": return <ChatsCircleIcon size={16} />;
    case "post": return <ChatCircleTextIcon size={16} />;
    case "fact_review": return <IdentificationCardIcon size={16} />;
    case "rule_review": return <NotePencilIcon size={16} />;
    case "data_setup": return <ChartLineUpIcon size={16} />;
    case "feedback": return <ChatsCircleIcon size={16} />;
    case "merge": return <GitMergeIcon size={16} />;
    case "plans_idle": return <MoonIcon size={16} />;
    case "product_idle": return <MoonIcon size={16} />;
    case "run_stalled": return <HourglassIcon size={16} />;
    default: return item.reason.code === "work_order_approval_expired" ? <ClockIcon size={16} /> : <WarningCircleIcon size={16} />;
  }
}
